import React from "react";
import styles from "./About.module.css";
import { useNavigate } from "react-router-dom";
import aboutImg1 from "../assets/kav.jpeg";
import PageBanner from "../components/PageBanner";
//import aboutImg from "../assets/1.png"; // Assuming you have an about image
import aboutImg from "../assets/slider3.png";
import CustomTitle from "../components/CustomTitle";
import LocationFooter from "./LocationFooter";

const team = [
  {
    name: "KAV prasad",
    title: "about1",
    role: "Founder",
    img: aboutImg1,
    desc: "Corporate law and M&A expert with 30+ years of experience.",
  },
  {
    name: "Dr Vani subramanyam",
    title: "about1",
    role: "expert Counselor",
    img: "https://randomuser.me/api/portraits/women/68.jpg",
    desc: "Civil litigation and dispute resolution specialist.",
  },
  {
    name: "Emily Chen",
    title: "about1",
    role: "Associate",
    img: "https://randomuser.me/api/portraits/women/65.jpg",
    desc: "Family law attorney focusing on custody and divorce cases.",
  },
  {
    name: "Michael Brown",
    title: "about1",
    role: "Expert",
    img: "https://randomuser.me/api/portraits/men/49.jpg",
    desc: "Intellectual property and patent law advisor.",
  },
];
const About = () => {
  const navigate = useNavigate();
  return (
    <>
      <PageBanner image={aboutImg} title="About Us" />
      <section className={styles.aboutSection}>
        <div className={styles.aboutContent}>
          <CustomTitle>ABOUT KASIBHATLAWS </CustomTitle>
          <p>
            <b>Founder of KASIBHATLAWS</b>
          </p>
          <p> K. A. V. Prasad</p>
          <p>BCOM BLAW IR&PM</p>
          <p>
            At the helm of the firm is K A V PRASAD, a distinguished legal
            professional with over 35 years of rich experience in diverse
            practice areas. A trusted advisor and formidable advocate, PRASAD
            has successfully represented clients before various courts,
            tribunals, and regulatory authorities across India. Civil & Criminal
            Law: Handled a wide spectrum of disputes, from complex civil suits
            and property matters to high-stakes criminal defense and prosecution
            cases. Corporate & Commercial Law: Guided corporations in mergers,
            acquisitions, contract management, and compliance, ensuring smooth
            business operations within the legal framework. Labor & Employment:
            Advised leading organizations and workers’ unions, striking a
            balance between regulatory compliance and protection of employee
            rights. Mining & Regulatory: Provided expert counsel to mining
            companies, contractors, and investors on licensing, environmental
            clearances, compliance, and disputes under mining laws and sectoral
            regulations. Family Law: Represented individuals with empathy and
            discretion in sensitive matrimonial, custody, and inheritance
            matters. Known for strategic insight, ethical practice, and
            client-focused solutions, Prasad has built the firm’s reputation on
            trust and results. Their leadership combines courtroom advocacy with
            corporate advisory skills, making the firm a one-stop destination
            for clients seeking reliable legal representation.
          </p>
          <p>
            "As the founder of KASIBHTALAWS , my vision has always been clear —
            to build a practice rooted in integrity, professionalism, and an
            unwavering commitment to justice. Law is not merely about statutes
            and procedures; it is about people, their rights, their businesses,
            and their futures. Every client who entrusts us with their case
            deserves more than just representation — they deserve understanding,
            strategy, and results." "Over the years, I have had the privilege of
            working across diverse areas of law — from civil and criminal
            litigation to corporate advisory, labor disputes, commercial
            transactions, mining, regulatory compliance, and family law matters.
            This wide spectrum of practice has not only enriched my experience
            but has also strengthened my belief that effective legal service
            requires a blend of knowledge, foresight, and compassion." "At
            KASIBHATLAWS, we measure our success not just in victories inside
            the courtroom, but in the confidence and trust our clients place in
            us. My commitment is to continue leading this firm with the same
            values that have defined my journey — dedication, fairness, and
            excellence in service. Together with my team."
          </p>
          <p>— KAV PRASAD Founder & Principal Counsel</p>
        </div>
        <div className={styles.aboutImg}>
          <img src={aboutImg1} alt="KASIBHATLAWS" />
        </div>
      </section>
      {/*  <div className="attorneysContainer">
        <CustomTitle>Meet Our Team </CustomTitle>
        <div className="grid" onClick={() => navigate("/about1")}>
          {team.map((t, i) => (
            <div className="card" key={i}>
              <img src={t.img} alt={t.name} className="avatar" />
              <h2>{t.name}</h2>
              <span className="role">{t.role}</span>
              <p>{t.desc}</p>
            </div>
          ))}
        </div> 
      </div>*/}
      {/*   <LocationFooter /> */}
    </>
  );
};

export default About;
